<template>
    <div class="thanks">
        <div class="yellow-bar">
            <div class="visual">
                <img src="/static/img/bedankt-visual.jpg" />
                <div class="shadow"></div>
            </div>
        </div>
        <div class="other-content">
            <h2>Bedankt voor het meespelen!</h2>
            <p v-if="isVersion2">Je maakt kans op
                <template v-for="(item, index) of numBonuses">
                    <template><span v-html="item.name"></span><template>{{ index + 2 < numBonuses.length ? ', ' : ( index < numBonuses.length - 1 ? ' en ' : '' ) }}</template></template>
                </template>!
            </p>
            <p v-else>Je maakt nu kans op <strong>&euro;&nbsp;{{ dottify( money ) }}</strong>!</p>

            <template v-if="isVersion2 && numBonuses.length !== 5">
                <h2>Kans maken op meer prijzen?</h2>
                <p>Dat kan! Doe zo vaak mee als je wilt. Maar let op, alleen je laatste deelname telt. Nog een kans wagen?</p>
                <button class="replay-button black" @click="playAgain">Speel opnieuw</button>
            </template>
            <template v-else-if="!isVersion2">
                <h2>Wil jij dit bedrag verbeteren?</h2>
                <p>Dat mag! Doe zo vaak mee als je wilt. Je maakt uiteindelijk kans met je hoogste behaalde geldprijs.</p>
                <button class="replay-button black" @click="playAgain">Speel opnieuw</button>
            </template>

            <template v-if="!isVersion2">
                <h2>Vertel je vrienden over deze actie.</h2>
                <v-social></v-social>
            </template>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import Social from '@/app/components/Social';
    import { dottify, tracking } from '@/app/mixins';

    export default {
        components: {
            'v-social': Social
        },

        mixins: [ dottify, tracking ],

        data()
        {
            return {
                prizeNames: [ '1&nbsp;van&nbsp;de&nbsp;5&nbsp;Rituals&nbsp;Pakketten', 'een&nbsp;Sonos&nbsp;Beam', 'een&nbsp;Sonos&nbsp;Play&nbsp;1', '1&nbsp;van&nbsp;de&nbsp;4&nbsp;Apple&nbsp;iPads', '1&nbsp;van&nbsp;de&nbsp;3&nbsp;LG&nbsp;TV’s' ]
            };
        },

        computed: {
            isVersion2()
            {
                return this.$store.getters.isVersion2;
            },

            money()
            {
                return this.$store.getters[ 'game/score' ];
            },

            bonuses()
            {
                return this.$store.getters[ 'game/bonuses' ];
            },

            numBonuses()
            {
                let arr = [];

                for( let i = 0; i < this.bonuses.length; i++ )
                {
                    if( this.bonuses[i] === 1 )
                    {
                        arr.push({
                            index: i,
                            name: this.prizeNames[i]
                        });
                    }
                }

                return arr;
            }
        },

        methods: {
            playAgain( e )
            {
                this.trackEvent( 'Klik op button - Speel opnieuw', 'Link tracking', window.location.origin + '/spel' );
                this.$router.replace( '/spel' );
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Thanks.vue